var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tender-award-attach-po", attrs: { id: _vm.zoneId } },
    [
      !_vm.readonly && _vm.dropzoneHeaders
        ? _c(
            "dropzone",
            {
              ref: "dropzone",
              attrs: {
                id: "dropzone-" + new Date().getTime(),
                url: _vm.baseURL + "/docs/",
                maxFileSizeInMB: _vm.docUploadSize,
                maxNumberOfFiles: 100,
                acceptedFileTypes: _vm.docUploadTypes,
                headers: _vm.dropzoneHeaders,
                uploadMulti: "true",
                previewTemplate: _vm.template,
                hiddenInputContainer: _vm.hiddenInputContainer,
              },
              on: {
                "vdropzone-file-added": _vm.clearMessages,
                "vdropzone-sending": _vm.preSendRequest,
                "vdropzone-success": _vm.uploadSuccess,
                "vdropzone-error": _vm.setErrorMessage,
                "vdropzone-queue-complete": _vm.queueComplete,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "dz-default dz-message  attach-po-btn inputContainer",
                },
                [
                  _c("span", { staticClass: "btn btn--darkblue" }, [
                    _vm._v(_vm._s(_vm.btnName)),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "token", value: "file upload" },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.totalCount,
              expression: "totalCount",
            },
          ],
          staticClass: "clearfix",
          staticStyle: { color: "#0C3A58" },
        },
        [_c("span", [_vm._v(_vm._s(_vm.totalCount) + " files uploading")])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.uploadResult,
              expression: "uploadResult",
            },
          ],
          staticClass: "clearfix",
          staticStyle: { color: "#0C3A58" },
        },
        [_c("span", [_vm._v(_vm._s(_vm.uploadResult))])]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errorMessage,
              expression: "errorMessage",
            },
          ],
        },
        [_c("span", [_vm._v(_vm._s(_vm.errorMessage))])]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
      _vm._v(" "),
      _c(
        "table",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.files.length > 0,
              expression: "files.length>0",
            },
          ],
          staticClass: "tender-tnc-table",
        },
        [
          _c("thead", [
            _c("th", { staticClass: "number tender-font" }, [
              _vm._v("\n        #\n      "),
            ]),
            _vm._v(" "),
            _c("th", { staticClass: "filename tender-font" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("tender.attachment.document")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            !(_vm.readonly || _vm.isAllFreeze) ? _c("th") : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _vm._l(_vm.files, function (item, index) {
                return [
                  _c("tr", { key: item.id, staticClass: "set-border-top" }, [
                    _c("td", { staticClass: "number tender-font" }, [
                      _vm._v(
                        "\n            " + _vm._s(index + 1) + "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticClass: "filename tender-font" }, [
                      _c(
                        "a",
                        {
                          staticStyle: {
                            "text-decoration": "underline",
                            "word-break": "break-all",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.downloadFile(item.id)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.filename) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    !(_vm.readonly || _vm.isAllFreeze)
                      ? _c("td", { staticClass: "description tender-font" }, [
                          !_vm.isFreeze(item)
                            ? _c(
                                "div",
                                {
                                  staticClass: "file-upload-delete",
                                  on: {
                                    click: function ($event) {
                                      return _vm.deleteFile(index, item)
                                    },
                                  },
                                },
                                [_vm._v("\n              ✕\n            ")]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]),
                ]
              }),
            ],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }